const intervalFirst = 7000
const intervalMulti = 400

export const state = () => ({
  toasterAlert: [],
  // {
  //   icon: '',
  //   text: '',
  //   type: 'error | warning | success | info',
  //   isClose: false,
  // }

  isTimerRunning: false, // Флаг для отслеживания состояния таймера
})

export const mutations = {
  setToasterAlert(state, payload) {
    state.toasterAlert.unshift(payload)
  },
  removeToasterAlert(state) {
    state.toasterAlert.pop() // Удаляем последний элемент
  },
  removeToasterAlertIndex(state, index) {
    state.toasterAlert.splice(index, 1) // Удаляем элемент по индексу
  },
  setTimerRunning(state, status) {
    state.isTimerRunning = status // Управляем флагом таймера
  },
}

export const actions = {
  show_notify({ commit, state }, data) {
    const repeatAlertIndex = state.toasterAlert.findIndex(alert => alert.text === data.text)
    const isRepeatAlert = repeatAlertIndex !== -1

    if (state.toasterAlert.length && isRepeatAlert) return false

    commit('setToasterAlert', data)

    const delay = data.delay || intervalFirst

    if (!state.isTimerRunning) {
      commit('setTimerRunning', true)

      setTimeout(() => {
        commit('removeToasterAlert')
        const timer = setInterval(() => {
          if (state.toasterAlert.length > 0) {
            commit('removeToasterAlert')
          }
          else {
            clearInterval(timer)
            commit('setTimerRunning', false)
          }
        }, intervalMulti)

      }, delay)
    }
  },
  close_toaster({ commit }) {
    commit('removeToasterAlert')
  },
}

export const getters = {
  getToasterAlert: (state) => state.toasterAlert,
}
